module.exports = __webpack_public_path__ + "static/media/intro3.2c6fb2a7.gif";